import React from 'react';
import { MemberAddEditPaymentInformation } from 'ui/containers/MemberAddEditPaymentInformation';
import { withNetworkState } from 'ui/hoc/withNetworkState';

import { memberAddEditAddresspreloader as MemberAddEditAddresspreloader } from 'ui/views/widgets/memberAddEditAddress';

const _memberDetailsPayBalanceSelectCard = ( props ) => {
	return (
		<div className="ui-pay-balance-select-card">
			{/* body view */}
			<div className="ui-pay-balance-select-card__body">
				<MemberAddEditPaymentInformation
					enableSelection={ true }
					displayTitle={ false }
					{ ...props }
				/>
			</div>
		</div>
	);
};

// preloader view
const shipppingAndPaymentPreloader = () => {
	return (
		<div className="ui-pay-balance-select-card-preloader">
			<MemberAddEditAddresspreloader hideTitle={ true } />
		</div>
	);
};

// set display name
_memberDetailsPayBalanceSelectCard.displayName = 'memberDetailsPayBalanceSelectCard';

// set default props
_memberDetailsPayBalanceSelectCard.defaultProps = {};

// prop types
_memberDetailsPayBalanceSelectCard.propTypes = {};

export const memberDetailsPayBalanceSelectCard = withNetworkState( shipppingAndPaymentPreloader, _memberDetailsPayBalanceSelectCard );
